import { render, staticRenderFns } from "./NearesTourButton.vue?vue&type=template&id=16123fde&"
import script from "./NearesTourButton.vue?vue&type=script&lang=js&"
export * from "./NearesTourButton.vue?vue&type=script&lang=js&"
import style0 from "./NearesTourButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports